import AccountPage from '../../common-components/component-library/profile/AccountPage';
import withAppProps from '../../utils/withAppProps';

export default AccountPage;

export const getServerSideProps = withAppProps();
